import { render, staticRenderFns } from "./IGAccountRow.vue?vue&type=template&id=92c78360&scoped=true"
import script from "./IGAccountRow.vue?vue&type=script&lang=js"
export * from "./IGAccountRow.vue?vue&type=script&lang=js"
import style0 from "./IGAccountRow.vue?vue&type=style&index=0&id=92c78360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c78360",
  null
  
)

export default component.exports